import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useForm } from "../../hooks/useForm/useForm";
import { Database } from "../../../../lib/supabase";
import { FormProps } from "../form-types";
import { Logger } from "../../../../lib/logger/Logger";
import { useCentralStore } from "../../store/Central";
import { showNotification } from "../../store/Central/selectors";
import { TpValue } from "../../types/enums";
import { BankAccountSelect } from "./bank-account/input-components/bank-account.select";
import { PriceListSelect } from "./price-list-select.component";
import { CustomToggleButtonGroup } from "../../components/custom-toggle-button/custom-toggle-button-group.component";
import { SupabaseWriteTableEnum } from "@/lib/supabase/supabaseTypes";
import { Button } from "../../components/ui/button";
import { useNavigate } from "react-router-dom";

export const CompanyAccountingInformation: React.FC<FormProps> = ({
	onSave = (org: any) => {},
	submitRef = null,
}) => {
	const organizationId = useCentralStore((state) => state.organization?.id);
	const navigate = useNavigate();
	const {
		handleUpdate,
		formData,
		formErrors,
		handleCheckboxChange,
		handleValueChange,
	} = useForm<
		Database["public"]["Tables"][SupabaseWriteTableEnum.ORGANIZATIONS]["Update"]
	>(
		{},
		SupabaseWriteTableEnum.ORGANIZATIONS,
		true,
		organizationId,
		"Rechnungswesen",
		() => {}
	);

	const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		if (!organizationId) {
			showNotification({
				message:
					"Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
				type: "error",
			});
			Logger.error(
				"No organizationId found in CompanyAccountingInformation"
			);
			return;
		}
		if (formData.default_tp_value == null) {
			showNotification({
				message: "Der Standard Tarifwert darf nicht leer sein.",
				type: "error",
			});
			return;
		}
		const { success, error, data } = await handleUpdate(
			event,
			organizationId
		);
		if (error) {
			showNotification({
				message:
					"Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
				type: "error",
			});
			return;
		}
		if (data) {
			const org = data[0];
			onSave(org);
			await useCentralStore.getState().getOrganization();
			showNotification({
				message:
					"Rechnungswesen-Einstellungen erfolgreich gespeichert.",
				type: "success",
			});
		}
	};

	return (
		<form onSubmit={onSubmit} className="flex flex-col gap-6 max-w-lg">
			{/* <div className="py-2 gap-1 flex flex-col">
				<div className="text-sm font-medium">
					Standard Tarifwert
				</div>
				<CustomToggleButtonGroup
					value={formData.default_tp_value}
					onChange={(value) => {
						handleValueChange("default_tp_value", value);
					}}
					options={[
						{ label: "5.55", value: TpValue.OLD },
						{ label: "1.0", value: TpValue.NEW },
					]}
					isInput
				/>
			</div> */}
			<div className="text-sm font-medium">
				Den Standard Tarifwert können Sie in den{" "}
				<div
					className="text-blue-500 font-bold inline-block cursor-pointer"
					onClick={() => {
						navigate("/organisation/administration/preislisten");
					}}
				>
					{" "}
					Preislisten-Einstellungen{" "}
				</div>{" "}
				anpassen.
			</div>
			<PriceListSelect
				value={formData.default_price_list_id || ""}
				onChange={(value) => {
					handleValueChange("default_price_list_id", value);
				}}
				helperText="Die Standard-Preisliste wird für neue Aufträge verwendet."
			/>
			<BankAccountSelect
				label="Standard Bankkonto"
				value={formData.default_bank_account_id?.toString() || ""}
				onChange={(value) => {
					handleValueChange("default_bank_account_id", value);
				}}
				helperText="Das Standard Bankkonto wird verwendet, wenn kein anderes Bankkonto für eine Rechnung angegeben wird."
			/>
			<Button type="submit">Speichern</Button>
		</form>
	);
};
